import * as React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";

import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";

import Checkbox from "@mui/material/Checkbox";
import { useEffect, useState } from "react";
import CheckboxGroup from "./CheckboxGroup/CheckboxGroup";
import useQueryParams, {
  BUSINESS_MODEL_PARAM,
  ACCOUNT_PARAM,
  CHANNEL_PARAM,
  COUNTRY_PARAM,
  DISTRIBUTION_METHOD_PARAM,
  ORDER_TYPE_PARAM,
  PRODUCT_ENGINE_PARAM,
  TERRITORY_PARAM,
} from "../../hooks/useQueryParams";
import { useLocation } from "react-router-dom";

import { recurseOverCountry } from "./JsonMenuBuilder";
import useClient from "../../hooks/useClient";
import { COUNTRIES, TERRITORY_MENU_DATA } from "./config/Filters";
import { NAV } from "./LeftNav.interface";
import {
  BE_TO_FE_VALUES,
  FE_TO_BE_VALUES,
} from "../../constants/app.constants";

const countryMenuData = [{ label: "MEXICO", value: "MEXICO" }];
const channelMenuData = [
  { label: "3PW", value: "3PW" },
  { label: "NSO", value: "NSO" },
  { label: "NVS", value: "NVS" },
  { label: "NDDC", value: "NDDC" },
];
const businessModelMenuData = [
  { label: "Nike Marketplace Partners", value: "NMP" },
  { label: "Nike Store Partners", value: "NSP" },
];
const accountMenuData: Array<NAV> = [];
const productEngineMenuData = [
  { label: "APPAREL", value: "AP" },
  { label: "EQUIPMENT", value: "EQ" },
  { label: "FOOTWEAR", value: "FW" },
];
const distributionMethodMenuData = [
  { label: "DC", value: "DC" },
  { label: "Direct Ship (DRS)", value: "DRS" },
];
const orderTypeMenuData = [{ label: "At Once", value: "AT_ONCE" }];
const FireNav = styled(List)({
  "& .MuiListItemButton-root": {
    paddingLeft: 24,
    paddingRight: 24,
  },
  "& .MuiListItemIcon-root": {
    minWidth: 0,
    marginRight: 16,
  },
  "& .MuiSvgIcon-root": {
    fontSize: 20,
  },
});

const allData = {
  [TERRITORY_PARAM]: TERRITORY_MENU_DATA,
  [PRODUCT_ENGINE_PARAM]: productEngineMenuData,
  [DISTRIBUTION_METHOD_PARAM]: distributionMethodMenuData,
  [ORDER_TYPE_PARAM]: orderTypeMenuData,
};

const PARAMETERS: Array<keyof Checks> = [
  TERRITORY_PARAM,
  CHANNEL_PARAM,
  COUNTRY_PARAM,
  PRODUCT_ENGINE_PARAM,
  BUSINESS_MODEL_PARAM,
  ACCOUNT_PARAM,
  DISTRIBUTION_METHOD_PARAM,
  ORDER_TYPE_PARAM,
];

export type Checks = {
  [TERRITORY_PARAM]: Set<string>;
  [CHANNEL_PARAM]: Set<string>;
  [COUNTRY_PARAM]: Set<string>;
  [PRODUCT_ENGINE_PARAM]: Set<string>;
  [BUSINESS_MODEL_PARAM]: Set<string>;
  [ACCOUNT_PARAM]: Set<string>;
  [DISTRIBUTION_METHOD_PARAM]: Set<string>;
  [ORDER_TYPE_PARAM]: Set<string>;
};

type CHECKS_KEYS =
  | "channel"
  | "account"
  | "country"
  | typeof BUSINESS_MODEL_PARAM;
const getDefaultValue = (
  value: { label: string; value: string }[],
  accessor = 0,
) => [value[accessor].value.toLowerCase()];

export const DEFAULT_CHECKS = {
  [TERRITORY_PARAM]: new Set<string>(getDefaultValue(TERRITORY_MENU_DATA)),
  [CHANNEL_PARAM]: new Set<string>(getDefaultValue(channelMenuData)),
  [COUNTRY_PARAM]: new Set<string>(getDefaultValue(countryMenuData)),
  [PRODUCT_ENGINE_PARAM]: new Set<string>(
    getDefaultValue(productEngineMenuData),
  ),
  [BUSINESS_MODEL_PARAM]: new Set<string>(
    getDefaultValue(businessModelMenuData),
  ),
  [ACCOUNT_PARAM]: new Set<string>(),
  [DISTRIBUTION_METHOD_PARAM]: new Set<string>(
    getDefaultValue(distributionMethodMenuData),
  ),
  [ORDER_TYPE_PARAM]: new Set<string>(getDefaultValue(orderTypeMenuData)),
};

export const getSetValues = (curr: keyof typeof DEFAULT_CHECKS) => {
  return Array.from(DEFAULT_CHECKS[curr]).join(",");
};

const defaultChecks = {
  [TERRITORY_PARAM]: new Set<string>([
    TERRITORY_MENU_DATA[0].value.toLowerCase(),
  ]),
  [CHANNEL_PARAM]: new Set<string>([channelMenuData[0].value.toLowerCase()]),
  [COUNTRY_PARAM]: new Set<string>([countryMenuData[0].value.toLowerCase()]),
  [PRODUCT_ENGINE_PARAM]: new Set<string>([
    productEngineMenuData[0].value.toLowerCase(),
  ]),
  [BUSINESS_MODEL_PARAM]: new Set<string>([
    businessModelMenuData[0].value.toLowerCase(),
  ]),
  [ACCOUNT_PARAM]: new Set<string>(),
  [DISTRIBUTION_METHOD_PARAM]: new Set<string>([
    distributionMethodMenuData[0].value.toLowerCase(),
  ]),
  [ORDER_TYPE_PARAM]: new Set<string>([
    orderTypeMenuData[0].value.toLowerCase(),
  ]),
};
const CHANGEABLE_NAVS = new Set([
  CHANNEL_PARAM,
  COUNTRY_PARAM,
  BUSINESS_MODEL_PARAM,
  ACCOUNT_PARAM,
]);

const createRecursionFields = () => {
  const labels = new Set<string>();
  const sets = {
    [COUNTRY_PARAM]: new Set<NAV>(),
    [CHANNEL_PARAM]: new Set<NAV>(),
    [BUSINESS_MODEL_PARAM]: new Set<NAV>(),
    [ACCOUNT_PARAM]: new Set<NAV>(),
  };

  return { labels, sets };
};
const createDefaults = (parameter: string) => {};
const DEFAULT_CHANNEL = channelMenuData[0].value.toLowerCase();
const DEFAULT_BUSINESS_MODEL = businessModelMenuData[0].value.toLowerCase();
export default function LeftNavFilters() {
  const [checks, setIsChecks] = useState<Checks>({ ...DEFAULT_CHECKS });
  const { pathname } = useLocation();
  const { role } = useClient();
  const {
    clearParams,
    queryParams,
    iterateOverParameters,
    setMultipleParameters,
    search,
  } = useQueryParams();

  const [changingNavs, setChangingNavs] = useState<{
    [key in CHECKS_KEYS]: Array<NAV>;
  }>({
    [CHANNEL_PARAM]: [...channelMenuData],
    [COUNTRY_PARAM]: [...countryMenuData],
    [BUSINESS_MODEL_PARAM]: [...businessModelMenuData],
    [ACCOUNT_PARAM]: [...accountMenuData],
  });
  const hideAccountFiltersMenu: boolean =
    changingNavs[ACCOUNT_PARAM].length === 0;
  useEffect(() => {
    const checked =
      queryParams.size > 0
        ? PARAMETERS.reduce((acc, parameter) => {
            const values = queryParams.get(parameter)?.split(",");
            const valueSet = new Set(values);
            return { ...acc, [parameter]: valueSet };
          }, {} as Checks)
        : DEFAULT_CHECKS;
    setIsChecks(checked);

    if (
      !search.length &&
      !role.toLowerCase().includes("admin") &&
      role !== "Unknown"
    ) {
      const territory = TERRITORY_MENU_DATA.find(
        (territory) => territory.label === role.toUpperCase(),
      );
      const { labels, sets } = createRecursionFields();
      if (territory) {
        territory.countries.forEach((country) => {
          sets[COUNTRY_PARAM].add({ label: country, value: country });
          recurseOverCountry(COUNTRIES[country], sets, labels);
        });
        const checked = { ...defaultChecks };
        checked[COUNTRY_PARAM] = new Set([
          territory.countries[0].toLowerCase(),
        ]);
        checked[BUSINESS_MODEL_PARAM] = new Set([DEFAULT_BUSINESS_MODEL]);
        checked[CHANNEL_PARAM] = new Set([DEFAULT_CHANNEL]);
        checked[TERRITORY_PARAM] = new Set([role.toLowerCase()]);
        setChecksAndNavs(checked, sets);
      } else {
        iterateOverParameters(DEFAULT_CHECKS);
      }
    } else {
      const { labels, sets } = createRecursionFields();
      const territories = queryParams.get(TERRITORY_PARAM)?.split(",");
      if (territories) {
        territories.forEach((territoryParam) => {
          const territory = TERRITORY_MENU_DATA.find(
            (territory) => territory.value === territoryParam.toUpperCase(),
          );
          if (territory) {
            territory.countries.forEach((country) => {
              sets[COUNTRY_PARAM].add({
                label: country,
                value: country,
              });
              recurseOverCountry(
                COUNTRIES[country.toUpperCase()],
                sets,
                labels,
              );
            });
          }
        });
      }
      createAndSetChangingNavs(sets);
    }
  }, [pathname, role]);
  useEffect(() => {
    if (role.toLowerCase().includes("admin") && search.length === 0) {
      selectAllChange();
    }
  }, [role, search]);
  const updatedAllData = { ...allData, ...changingNavs };
  const ALL_DATA_LENGTH = Object.values(updatedAllData).reduce(
    (acc, curr) => acc + curr.length,
    0,
  );
  const size = Object.values(checks).reduce((acc, curr) => acc + curr.size, 0);
  const createAndSetChangingNavs = (sets: any) => {
    const countries = [...sets[COUNTRY_PARAM]];
    const channels = [...sets[CHANNEL_PARAM]];
    const businessModels = [...sets[BUSINESS_MODEL_PARAM]];
    const accounts = [...sets[ACCOUNT_PARAM]];
    setChangingNavs({
      [CHANNEL_PARAM]: channels,
      [COUNTRY_PARAM]: countries,
      [BUSINESS_MODEL_PARAM]: businessModels,
      [ACCOUNT_PARAM]: accounts,
    });
  };
  const selectAllChange = () => {
    if (size < ALL_DATA_LENGTH) {
      const { labels, sets } = createRecursionFields();
      TERRITORY_MENU_DATA.forEach((territory) => {
        territory.countries.forEach((country) => {
          sets[COUNTRY_PARAM].add({ label: country, value: country });
          recurseOverCountry(COUNTRIES[country], sets, labels);
        });
      });
      createAndSetChangingNavs(sets);
      const newData = { ...allData, ...sets };
      const checkedData = Object.keys(newData).reduce((acc, c) => {
        const set = [...(newData[c] as Set<NAV>).values()];
        const labels = set.map((datum: NAV) => datum.value.toLowerCase());

        return { ...acc, [c]: new Set(labels) };
      }, {} as Checks);
      iterateOverParameters(checkedData);
      setIsChecks(checkedData);
    } else if (role.toLowerCase().includes("admin")) {
      const mexico = COUNTRIES.MEXICO;
      const { labels, sets } = createRecursionFields();
      sets[COUNTRY_PARAM].add({ label: "MEXICO", value: "MEXICO" });
      recurseOverCountry(mexico, sets, labels);
      clearParams();
      setIsChecks(defaultChecks);
      iterateOverParameters(defaultChecks);
      createAndSetChangingNavs(sets);
    } else {
      const territory = TERRITORY_MENU_DATA.find(
        (territory) => territory.label === role.toUpperCase(),
      );
      const { labels, sets } = createRecursionFields();
      if (territory) {
        territory.countries.forEach((country) => {
          sets[COUNTRY_PARAM].add({ label: country, value: country });
          recurseOverCountry(COUNTRIES[country], sets, labels);
        });
        const checked = { ...defaultChecks };
        checked[COUNTRY_PARAM] = new Set([
          territory.countries[0].toLowerCase(),
        ]);
        checked[BUSINESS_MODEL_PARAM] = new Set([DEFAULT_BUSINESS_MODEL]);
        checked[CHANNEL_PARAM] = new Set([DEFAULT_CHANNEL]);
        checked[TERRITORY_PARAM] = new Set([role.toLowerCase()]);
        setChecksAndNavs(checked, sets);
      }
    }
  };

  const addOrDeleteFromChecks = (parameterName: string, checkboxId: string) => {
    const checked: Set<string> = new Set(checks[parameterName]);
    if (checked.has(checkboxId)) {
      checked.delete(checkboxId);
    } else {
      checked.add(checkboxId);
    }
    return checked;
  };

  const resetNavAndChecks = (countryNav: NAV[], checked: Set<string>) => {
    const clearedNavs = {
      [COUNTRY_PARAM]: countryNav,
      [CHANNEL_PARAM]: [],
      [BUSINESS_MODEL_PARAM]: [],
      [ACCOUNT_PARAM]: [],
    };
    const clearedChecks = {
      ...checks,
      [COUNTRY_PARAM]: checked,
      [CHANNEL_PARAM]: new Set<string>(),
      [BUSINESS_MODEL_PARAM]: new Set<string>(),
      [ACCOUNT_PARAM]: new Set<string>(),
    };
    return { clearedNavs, clearedChecks };
  };
  const setChecksAndNavs = (updatedChecks: Checks, sets: any) => {
    iterateOverParameters(updatedChecks);
    setIsChecks(updatedChecks);
    createAndSetChangingNavs(sets);
  };
  const onChange = (parameterName: string) => (checkboxId: string) => {
    if (parameterName === TERRITORY_PARAM) {
      if (checks[TERRITORY_PARAM].has(checkboxId)) {
        const territories = new Set(checks[TERRITORY_PARAM]);
        territories.delete(checkboxId);
        if (territories.size === 0) {
          const { clearedNavs, clearedChecks } = resetNavAndChecks(
            [],
            new Set<string>(),
          );
          const updatedChecks = {
            ...checks,
            ...clearedChecks,
            [TERRITORY_PARAM]: territories,
          };
          setChecksAndNavs(updatedChecks, clearedNavs);
        } else {
          const iterableTerritories = Array.from(territories);
          const countries = iterableTerritories.flatMap((territory) => {
            const territoryData = TERRITORY_MENU_DATA.find(
              (territoryMenu) =>
                territory.toUpperCase() === territoryMenu.value,
            );
            // Won't happen
            if (!territoryData) return [];
            return territoryData.countries.map((country) => ({
              label: country,
              value: country,
            }));
          });
          const { labels, sets } = createRecursionFields();
          countries.forEach((country) => {
            sets[COUNTRY_PARAM].add(country);
            if (checks[COUNTRY_PARAM].has(country.value.toLowerCase())) {
              recurseOverCountry(
                COUNTRIES[country.value.toUpperCase()],
                sets,
                labels,
              );
            }
          });
          const uppercaseLabels = new Set(
            [...labels].map((label) => label.toUpperCase()),
          );
          const countryCheck = new Set(
            countries.map((country) => country.value.toUpperCase()),
          );
          const checked = Object.keys(checks)
            .filter((check) => CHANGEABLE_NAVS.has(check))
            .reduce((acc, c) => {
              const val = [...checks[c]].filter(
                (check) =>
                  uppercaseLabels.has(check.toUpperCase()) ||
                  countryCheck.has(check.toUpperCase()) ||
                  labels.has(BE_TO_FE_VALUES[check.toUpperCase()]),
              );
              return { ...acc, [c]: new Set(val) };
            }, {});
          const updatedChecks = {
            ...checks,
            ...checked,
            [TERRITORY_PARAM]: territories,
          };
          setChecksAndNavs(updatedChecks, sets);
        }
      } else {
        const territory = TERRITORY_MENU_DATA.find(
          (territory) => checkboxId.toUpperCase() === territory.value,
        );
        if (territory) {
          const countries = territory.countries.map((country) =>
            country.toLowerCase(),
          );
          const territories = [...checks[TERRITORY_PARAM], checkboxId];
          const checked = new Set(territories);
          const countryMenu = changingNavs.country.concat(
            countries.map((country) => ({
              label: country,
              value: country,
            })),
          );
          setMultipleParameters(TERRITORY_PARAM, checkboxId);
          setIsChecks({ ...checks, [TERRITORY_PARAM]: checked });
          setChangingNavs({
            ...changingNavs,
            [COUNTRY_PARAM]: countryMenu,
          });
        }
      }
    } else if (parameterName === COUNTRY_PARAM) {
      const checked = addOrDeleteFromChecks(parameterName, checkboxId);
      const { labels, sets } = createRecursionFields();
      if (checked.size === 0) {
        const { clearedNavs, clearedChecks } = resetNavAndChecks(
          countryMenuData,
          checked,
        );
        setChecksAndNavs(clearedChecks, clearedNavs);
      } else {
        changingNavs[COUNTRY_PARAM].forEach((country) => {
          sets[COUNTRY_PARAM].add(country);
          if (checked.has(country.value.toLowerCase())) {
            recurseOverCountry(
              COUNTRIES[country.value.toUpperCase()],
              sets,
              labels,
            );
          }
        });
        const updatedChecks = { ...checks, [COUNTRY_PARAM]: checked };
        if (checks[CHANNEL_PARAM].size === 0) {
          // Should only be 1 country at this point
          const country = [...checked][0];
          const channels = Object.keys(COUNTRIES[country.toUpperCase()]);
          const channel = channels[0];
          updatedChecks[CHANNEL_PARAM] = new Set([channel.toLowerCase()]);

          if (checks[BUSINESS_MODEL_PARAM].size === 0) {
            const businessModelKey = Object.keys(
              COUNTRIES[country.toUpperCase()][channel],
            )[0];
            const businessModel = FE_TO_BE_VALUES[businessModelKey];
            updatedChecks[BUSINESS_MODEL_PARAM] = new Set([
              businessModel.toLowerCase(),
            ]);
          }
        }
        setChecksAndNavs(updatedChecks, sets);
      }
    } else {
      const checked = addOrDeleteFromChecks(parameterName, checkboxId);
      setMultipleParameters(parameterName, checkboxId);
      setIsChecks({ ...checks, [parameterName]: checked });
    }
  };
  return (
    <Box minHeight="100vh" sx={{ display: "flex", borderRadius: 0 }}>
      <Paper
        style={{
          backgroundColor: "rgb(30, 30, 47)",
          color: "#fff",
          width: 250,
        }}
      >
        <FireNav disablePadding>
          <Box marginTop="80px">
            <ListItemButton
              sx={{ py: 0, minHeight: 62, color: "rgba(255,255,255,.8)" }}
              onClick={selectAllChange}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <ListItemIcon>
                  <Checkbox
                    name="selectAll"
                    checked={size === ALL_DATA_LENGTH}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={"Select All"}
                  primaryTypographyProps={{
                    fontSize: 14,
                    fontWeight: "medium",
                    color: "#fff",
                  }}
                  sx={{ marginTop: 1 }}
                />
              </div>
            </ListItemButton>
          </Box>
          <Divider />
          <CheckboxGroup
            checkboxes={TERRITORY_MENU_DATA}
            label={"Territory"}
            onChange={onChange(TERRITORY_PARAM)}
            checked={checks[TERRITORY_PARAM]}
          />
          <Divider />
          <CheckboxGroup
            checkboxes={changingNavs[COUNTRY_PARAM]}
            label={"Country"}
            onChange={onChange(COUNTRY_PARAM)}
            checked={checks[COUNTRY_PARAM]}
          />
          {pathname === "/" && (
            <>
              <Divider />
              <CheckboxGroup
                checkboxes={changingNavs[CHANNEL_PARAM]}
                label={"Channel"}
                onChange={onChange(CHANNEL_PARAM)}
                checked={checks[CHANNEL_PARAM]}
              />
              <Divider />
              <CheckboxGroup
                checkboxes={changingNavs[BUSINESS_MODEL_PARAM]}
                label={"Business Model"}
                onChange={onChange(BUSINESS_MODEL_PARAM)}
                checked={checks[BUSINESS_MODEL_PARAM]}
              />
            </>
          )}
          <Divider
            sx={{ display: hideAccountFiltersMenu ? "none" : "block" }}
          />
          <CheckboxGroup
            display={hideAccountFiltersMenu ? "none" : "block"}
            checkboxes={changingNavs[ACCOUNT_PARAM]}
            label={"Account"}
            onChange={onChange(ACCOUNT_PARAM)}
            checked={checks[ACCOUNT_PARAM]}
          />
          {pathname === "/" && (
            <>
              <Divider />
              <CheckboxGroup
                checkboxes={productEngineMenuData}
                label={"Product Engine"}
                onChange={onChange(PRODUCT_ENGINE_PARAM)}
                checked={checks[PRODUCT_ENGINE_PARAM]}
              />
              <Divider />
              <CheckboxGroup
                checkboxes={distributionMethodMenuData}
                label={"Futures"}
                onChange={onChange(DISTRIBUTION_METHOD_PARAM)}
                checked={checks[DISTRIBUTION_METHOD_PARAM]}
              />
              <Divider />
              <CheckboxGroup
                checkboxes={orderTypeMenuData}
                label={"At Once"}
                onChange={onChange(ORDER_TYPE_PARAM)}
                checked={checks[ORDER_TYPE_PARAM]}
              />
            </>
          )}
          <Divider />
        </FireNav>
      </Paper>
    </Box>
  );
}
